import _ from '@lodash';
import * as yup from 'yup';
import { format } from 'date-fns';
import { useHistory } from 'react-router';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import OptimizationCaseTaskEditService from 'app/admin/taskManager/service/OptimizationCaseTaskEditService';

export function RunOptimizationDialog(props) {
    const history = useHistory();
    const { t } = useTranslation(['common']);
    const dispatch = useDispatch();

    const schema = yup.object().shape({
        name: yup.string().nullable().required(t('validation:FIELD_REQUIRED'))
    });

    const getDefaultValues = () => {
        let defaultValues = { name: props.optimizationCase.name + ' - ' + format(new Date(), 'yyyy.MM.dd. HH:mm') };
        // if (props.readerId) defaultValues.readerId = props.readerId;
        return defaultValues;
    };

    const methods = useForm({
        defaultValues: getDefaultValues(),
        mode: 'onChange',
        resolver: yupResolver(schema)
    });

    const handleSave = value => {
        OptimizationCaseTaskEditService.save({ "id": null, "name": value.name, "type": "Optimize", "optimizationCase": props.optimizationCase.id, "enabled": true }).then(response => { handleResponse(response) }).catch(err => handleCatch(err));
    };

    const handleResponse = (response) => {
        dispatch(showMessage({ message: 'Successful' }));
        props.onCancel();
    };

    const handleCatch = (error) => {
        dispatch(showMessage({ message: 'Error' }));
    };

    const handleCancel = () => {
        props.onCancel();
    };

    return (
        <Dialog open fullWidth>

            <DialogTitle disableTypography className="border-b">
                Run Optimization Case
            </DialogTitle>

            <DialogContent className="p-20">

                <FormProvider {...methods}>
                    <Controller
                        control={methods.control}
                        name="name"
                        render={({ field, fieldState }) => (
                            <EditFormTextField
                                field={field}
                                fieldState={fieldState}
                                config={{ topic: 'common' }}
                                fieldConfig={{
                                    key: 'name',
                                    text: 'Name',
                                    required: true
                                }}
                            />
                        )}
                    />
                </FormProvider>

            </DialogContent>

            <DialogActions className="justify-between border-t p-20">

                <Button onClick={() => { handleCancel(); }}>
                    {t('CANCEL')}
                </Button>

                <Button onClick={methods.handleSubmit(handleSave)} color="primary" autoFocus>
                    Run
                </Button>

            </DialogActions>

        </Dialog >
    );
}
export default RunOptimizationDialog;
